(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["two-column-collapsible"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.collapse-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      // Close all other items
      headers.forEach(h => {
        if (h !== header) {
          h.classList.remove('active');
          h.nextElementSibling.style.display = 'none';
        }
      });

      // Toggle current
      header.classList.toggle('active');
      const body = header.nextElementSibling;

      if (body.style.display === 'block') {
        body.style.display = 'none';
      } else {
        body.style.display = 'block';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
